import { NodeModel } from '@minoru/react-dnd-treeview';
import fileDownload from 'js-file-download';
import { createContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { ContextProps } from './contextProps';
import { ProviderProps } from './providerProps';

import { InterruptionsAPI, WorkshiftsSchedulingAPI, requests } from '../../services/external/APIs';

import englishLang from '../../i18n/resources.en.json';
import spanishLang from '../../i18n/resources.es.json';
import defaulltLang from '../../i18n/resources.json';

import { useGetConfigurations, useGetWorkshiftsList } from '../hooks';

import {
  AssignedModalCostCenterProps,
  AssignedModalProps,
  DisassociateBusinessUnitModel,
  DisassociateBusinessUnitsModal,
  DisassociateCostCenterModal,
  DisassociateCostCenterModel,
  DownloadReportsModel,
  EmployeeNodeModel,
  InterruptionModel,
  InterruptionsListModel,
  LanguageModel,
  ModalProps,
  UpdateAndDeleteAdditionalsModalInfo,
  UpdateAndDeleteModalInfo,
  WorkshiftSchedulingModel,
  WorkshiftSchedulingsIds,
  WorkshiftsListModel,
  WorkshiftsSchedulingsCopied,
} from '../../models';
import { AuthenticatedUserModel } from '../../models/security';

import {
  ACTIONS,
  ASSIGNED_MODAL_COST_CENTER_PROPS_EMPTY,
  ASSIGNED_MODAL_PROPS_EMPTY,
  DISASSOCIATE_BUSINESS_UNITS_MODAL_EMPTY,
  DISASSOCIATE_COST_CENTER_MODAL_EMPTY,
  Lang_Types,
  LocalStorage_keys,
  MODAL_PROPS_EMPTY,
  UPDATE_AND_DELETE_ADDITIONALS_MODAL_INFO_EMPTY,
  UPDATE_AND_DELETE_MODAL_INFO_EMPTY,
  WORKSHIFTS_SCHEDULINGS_COPIED_EMPTY,
} from '../../constants';
import {
  InconsistenciesByEmployeeModel,
  InconsistenciesByPeopleModel,
} from '../../models/inconsistencies-validation/inconsistenciesValidation';
import { InconsistenciesValidationRequest } from '../../models/inconsistencies-validation/inconsistenciesValidationRequest';
import { InconsistenciesValidationAPI } from '../../services/external/APIs/inconsistencies-validation/InconsistenciesValidation';
import { compareTwoDates, formatDate, getChildNodes, getEmployeesIds } from '../../utils';
import { getActionService } from '../../utils/getActionService';
import { TimeAttendanceEvent } from '../components/modals/time-attendance-events/TimeAttendanceEvent';
import { skins } from '../../config/skins';

export const AppContext = createContext({} as ContextProps);

// Provee a toda los componentes que esten envueltos toda la logica y estados que se manejaran a nivel global
export const AppProvider = ({ children }: ProviderProps) => {
  const [startDateScheduling, setStartDateScheduling] = useState('');

  const [endDateScheduling, setEndDateScheduling] = useState('');

  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeNodeModel[]>([]);

  const initialUser = localStorage.getItem('user');
  const [isCollapseTree, setIsCollapseTree] = useState(false);

  const [userInfo, setuserInfo] = useState<AuthenticatedUserModel>(
    initialUser ? JSON.parse(initialUser) : null,
  );
  const [employeesSelectedBackup, setEmployeesSelectedBackup] = useState<NodeModel[]>([]);

  const [isLoadingWorkshifts, setIsLoadingWorkshifts] = useState(false);
  const [employeesToShowTable, setEmployeesToShowTable] = useState<EmployeeNodeModel[]>(
    [] as EmployeeNodeModel[],
  );

  const {
    interruptionTypesList,
    holidaysList,
    aidTypesList,
    areasList,
    businessUnitsList,
    groupList,
    hourTypes,
    parametersApplication,
    interruptionReferenceTypesList,
    interruptionTypesByEmployeePortalList,
    interruptionTypesByUserList,
  } = useGetConfigurations(userInfo);

  const [workshiftUsed, setWorkshiftUsed] = useState<number[]>([]);

  const {
    workshiftList,
    workshiftListCopy,
    isLoadingDataList,
    setIsLoadingData,
    setWorkshiftListCopy,
    setWorkshiftList,
  } = useGetWorkshiftsList();

  useEffect(() => {
    if (workshiftUsed.length > 0) {
      let workshifts = workshiftList?.filter((w) => !workshiftUsed.includes(w.id));

      let workshiftsUsed = workshiftList?.filter((w) => workshiftUsed.includes(w.id));

      if (workshifts !== undefined && workshiftsUsed !== undefined) {
        let newWorkshifts = workshiftsUsed.concat(workshifts);

        setWorkshiftListCopy(newWorkshifts);
      }
    } else {
      setWorkshiftListCopy(workshiftList);
    }
    setIsLoadingData(false);
  }, [workshiftUsed]);

  const [grid, setGrid] = useState(null);

  const [showEmployeesTable, setShowEmployeesTable] = useState(false);

  const [lang, setLang] = useState(
    window.localStorage.getItem(LocalStorage_keys.LANG_KEY) ?? Lang_Types['ES-CO'],
  );

  const [isSkinSmart, setIsSkinSmart] = useState(process.env.REACT_APP_SKIN == 'smart');

  const defaultSkinKey = process.env.REACT_APP_SKIN || 'siesa';
  const [activeSkinKey, setSkin] = useState(defaultSkinKey);
  const activeSkinConfig = skins[activeSkinKey] || skins['siesa'];

  const [appVersion, setAppVersion] = useState(process.env.REACT_APP_VERSION ?? '');

  const [workshiftsSchedulingsCopied, setWorkshiftsSchedulingsCopied] =
    useState<WorkshiftsSchedulingsCopied>(WORKSHIFTS_SCHEDULINGS_COPIED_EMPTY);

  const [langResources, setLangResources] = useState<LanguageModel>(spanishLang);

  const [workshiftShedulingList, setWorkshiftShedulingList] = useState<WorkshiftsListModel>(
    {} as WorkshiftsListModel,
  );

  const [interruptionList, setInterruptionList] = useState<InterruptionsListModel>(
    {} as InterruptionsListModel,
  );

  const [allTimeAttendanceEvents, setAllTimeAttendanceEvents] = useState<TimeAttendanceEvent[]>([]);

  const [isOpenBonusModal, setIsOpenBonusModal] = useState(false);
  const [modalInfoBonus, setModalInfoBonus] = useState<ModalProps>(MODAL_PROPS_EMPTY);

  const [inconsistenciesValidation, setInconsistenciesValidation] =
    useState<InconsistenciesByPeopleModel>({} as InconsistenciesByPeopleModel);
  const [isOpenInconsistenciesModal, setIsOpenInconsistenciesModal] = useState(false);

  const [isOpenWorkshiftModal, setIsOpenWorkshiftModal] = useState(false);
  const [isOpenDeleteWorkshiftModal, setIsOpenDeleteWorkshiftModal] = useState(false);
  const [isOpenCreateInterruptionModal, setIsOpenCreateInterruptionModal] = useState(false);
  const [isOpenUpdateAndDeleteModal, setIsOpenUpdateAndDeleteModal] = useState(false);
  const [isOpenUpdateAndDeleteAdditionalHoursModal, setIsOpenUpdateAndDeleteAdditionalHoursModal] =
    useState(false);
  const [isOpenAdditionalHoursModal, setIsOpenAdditionalHoursModal] = useState(false);
  const [isOpenCostCenterModal, setIsOpenCostCenterModal] = useState(false);
  const [isOpenBusinessUnitsModal, setIsOpenBusinessUnitsModal] = useState(false);
  const [isOpenDisassociatedCostCenterModal, setIsOpenDisassociatedCostCenterModal] =
    useState(false);
  const [isOpenDisassociatedBusinessUnitsModal, setIsOpenDisassociatedBusinessUnitsModal] =
    useState(false);
  const [isOpenAidTypesModal, setIsOpenAidTypesModal] = useState(false);
  const [isOpenCreateMarkingModal, setIsOpenCreateMarkingModal] = useState(false);
  const [isOpenModifyMarkingModal, setIsOpenModifyMarkingModal] = useState(false);
  const [isOpenDetailsInconsistenciesModal, setIsOpenDetailsInconsistenciesModal] = useState(false);

  const [isOpenOperationsCenterModal, setIsOpenOperationsCenterModal] = useState(false);
  const [isDeleteOperationsCenterModal, setIsDeleteOperationsCenterModal] = useState(false);
  const [isOpenWorkshiftsSundaysUsualsModal, setIsOpenWorkshiftsSundaysUsualsModal] =
    useState(false);

  const [workshiftsSundaysUsualsModal, setWorkshiftsSundaysUsualsModal] = useState({});

  const [detailsInconsistenciesModal, setDetailsInconsistenciesModal] = useState({});

  const [inconsistenciesModal, setInconsistenciesModal] = useState({});
  const [inconsistenciesTypesToFilter, setInconsistenciesTypesToFilter] = useState<number[]>([]);

  const [modalInfoOperationsCenter, setModalInfoOperationsCenter] =
    useState<ModalProps>(MODAL_PROPS_EMPTY);

  const [openAlertModal, setOpenAlertModal] = useState({
    isOpen: false,
    message: '',
    value: '',
  });
  //Módulo no implementado a solicitud
  const [moldaAidTypesInfo, setMoldaAidTypesInfo] = useState({
    date: '',
    employee: {} as EmployeeNodeModel,
  });

  const [modalInfoInterruption, setModalInfoInterruption] = useState<ModalProps>(MODAL_PROPS_EMPTY);

  const [modalInfoWorkshift, setModalInfoWorkshift] = useState<ModalProps>(MODAL_PROPS_EMPTY);

  const [modalUpdatedAndDeleteInfo, setModalUpdatedAndDeleteInfo] =
    useState<UpdateAndDeleteModalInfo>(UPDATE_AND_DELETE_MODAL_INFO_EMPTY);

  const [modalAddtionalInfo, setModalAddtionalInfo] = useState<AssignedModalProps>(
    ASSIGNED_MODAL_PROPS_EMPTY,
  );

  const [modalUpdatedAndDeleteAdditionalHours, setModalUpdatedAndDeleteAdditionalHours] =
    useState<UpdateAndDeleteAdditionalsModalInfo>(UPDATE_AND_DELETE_ADDITIONALS_MODAL_INFO_EMPTY);

  const [modalAssociateCostCenter, setModalAssociateCostCenter] =
    useState<AssignedModalCostCenterProps>(ASSIGNED_MODAL_COST_CENTER_PROPS_EMPTY);

  const [modalAssociateBusinessUnits, setModalAssociateBusinessUnits] =
    useState<AssignedModalProps>(ASSIGNED_MODAL_PROPS_EMPTY);

  const [modalDisassociateCostCenter, setModalDisassociateCostCenter] =
    useState<DisassociateCostCenterModal>(DISASSOCIATE_COST_CENTER_MODAL_EMPTY);

  const [modalDisassociateBusinessUnits, setModalDisassociateBusinessUnits] =
    useState<DisassociateBusinessUnitsModal>(DISASSOCIATE_BUSINESS_UNITS_MODAL_EMPTY);

  const [modalCreateMarking, setModalCreateMarking] = useState<any>({});
  const [modalModifyMarking, setModalModifyMarking] = useState<any>({});
  const [isRequestHistoryModalOpen, setIsRequestHistoryModalOpen] = useState(false);

  const [
    isOpenMultipleCostCentersByHourRangesModal,
    setIsOpenMultipleCostCentersByHourRangesModal,
  ] = useState(false);
  const [modalInfoMultipleCostCentersByHourRanges, setModalInfoMultipleCostCentersByHourRanges] =
    useState<any>({});
  const [isOpenCostCenterScheduleResultsModal, setIsOpenCostCenterScheduleResultsModal] =
    useState(false);
  const [costCenterScheduleResults, setCostCenterScheduleResults] = useState<{
    acceptedCostCenterSchedules: any[];
    rejectionOfCostCenterSchedules: any[];
  }>({
    acceptedCostCenterSchedules: [],
    rejectionOfCostCenterSchedules: [],
  });

  //Al cargar la aplicación definimos que skin se va usar y el lenguaje
  useEffect(() => {
    switch (lang) {
      case Lang_Types['ES-CO']:
        setLangResources(spanishLang);
        break;

      case Lang_Types['EN-US']:
        setLangResources(englishLang);
        break;

      default:
        setLangResources(defaulltLang);
        break;
    }
  }, [lang]);

  useEffect(() => {
    document.getElementById('root')?.setAttribute('class', activeSkinConfig.rootClass);
  }, [activeSkinKey, activeSkinConfig]);

  /**
   * Al pasarle las fechas y empleados el se encarga de consultar las programaciones
   * @param selectedEmployees NodeModel[]
   * @param startDate string
   * @param endDate string
   * @param showMesage boolean
   */
  const handleConsultScheduling = (
    selectedEmployees: NodeModel[],
    startDate: string,
    endDate: string,
    showMesage: boolean,
    workshiftIds: number[],
  ) => {
    if (getActionService(userInfo.actions, ACTIONS['search.scheduling'])) {
      if (
        startDate.trim() === '' ||
        endDate.trim() === '' ||
        startDate > endDate ||
        selectedEmployees.length === 0
      ) {
        toast.error(langResources['loaders.upload.workshiftsList.failed'], {
          autoClose: 5000,
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setShowEmployeesTable(false);
      } else {
        if (selectedEmployees.length > 0) {
          let id: any;
          let id2: any;
          if (showMesage) {
            id = toast.loading(langResources['loaders.loading.interruptions.title'] + '...');

            id2 = toast.loading(langResources['loaders.loading.workshifts.title'] + '...');
          }

          const employeesIDs = getChildNodes(selectedEmployees).map((emp) => emp.id);

          const body = {
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
            employeeIds: employeesIDs,
            workshiftIds,
          };
          setIsLoadingWorkshifts(true);
          WorkshiftsSchedulingAPI.getListScheduling(body)
            .then((res) => {
              if (showMesage)
                toast.update(id, {
                  render: langResources['loaders.upload.workshiftsList.success'],
                  type: 'success',
                  isLoading: false,
                  autoClose: 5000,
                  position: toast.POSITION.BOTTOM_RIGHT,
                  closeOnClick: true,
                  closeButton: true,
                });
              setIsLoadingWorkshifts(false);

              setWorkshiftShedulingList(res);
            })
            .catch((err) => {
              if (showMesage)
                toast.update(id, {
                  render: langResources['loaders.loading.workshifts.error'],
                  type: 'error',
                  isLoading: false,
                  autoClose: 5000,
                  position: toast.POSITION.BOTTOM_RIGHT,
                  closeOnClick: true,
                  closeButton: true,
                });
              setIsLoadingWorkshifts(false);

              setWorkshiftShedulingList({} as WorkshiftsListModel);
            });

          InterruptionsAPI.getListInterruptions(body)
            .then((res) => {
              setInterruptionList(res);
              toast.update(id2, {
                render: langResources['loaders.upload.interruptionsList.success'],
                type: 'success',
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
              });
            })
            .catch((err) => {
              if (showMesage)
                toast.update(id2, {
                  render: langResources['loaders.loading.interruptions.error'],
                  type: 'error',
                  isLoading: false,
                  autoClose: 5000,
                  position: toast.POSITION.BOTTOM_RIGHT,
                  closeOnClick: true,
                  closeButton: true,
                });
              setInterruptionList({} as InterruptionsListModel);
            });
        }
        setShowEmployeesTable(true);

        if (showMesage) {
          setInconsistenciesValidation({} as InconsistenciesByPeopleModel);
        }
      }
    }
  };

  /**
   * Validaciones de las novedades de los empleados
   */
  const handlerValidateNovelties = (
    selectedEmployees: NodeModel[],
    startDate: string,
    endDate: string,
    inconsistencyTypesIds: number[],
  ) => {
    let body: InconsistenciesValidationRequest = {
      startDate: startDate + 'T01:00',
      endDate: endDate + 'T01:00',
      employeeIds: selectedEmployees
        .filter(
          (employee) =>
            //@ts-ignore
            employee?.documentNumber,
        )
        .map((employeeId) => Number(employeeId.id)),
      inconsistencyTypesIds: inconsistencyTypesIds,
    };

    if (body.startDate !== '' && body.endDate !== '' && body.employeeIds.length > 0) {
      let id = toast.loading('Validando novedades...');

      InconsistenciesValidationAPI.getAll(body)
        .then((res) => {
          if (res.employeeIds.length > 0) {
            toast.update(id, {
              render: 'Inconsistencias validadas correctamente',
              type: 'success',
              isLoading: false,
              autoClose: 5000,
              position: toast.POSITION.BOTTOM_RIGHT,
              closeOnClick: true,
              closeButton: true,
            });

            setInconsistenciesValidation(res);
            handleConsultScheduling(
              selectedEmployees.filter((e) => res.employeeIds.includes(Number(e.id))),
              startDate,
              endDate,
              false,
              [],
            );
            setEmployeesToShowTable(
              selectedEmployees.filter((e) => res.employeeIds.includes(Number(e.id))),
            );
          } else {
            setInconsistenciesValidation({} as InconsistenciesByPeopleModel);

            handleConsultScheduling(employeesSelectedBackup, startDate, endDate, false, []);
            setEmployeesToShowTable(employeesSelectedBackup);
            toast.update(id, {
              render: 'No existen inconsistencias para estos empleados',
              type: 'warning',
              isLoading: false,
              autoClose: 5000,
              position: toast.POSITION.BOTTOM_RIGHT,
              closeOnClick: true,
              closeButton: true,
            });
          }
        })
        .catch((err) => {
          setInconsistenciesValidation({} as InconsistenciesByPeopleModel);

          toast.update(id, {
            render: 'Error al cargar inconsistencias',
            type: 'error',
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
          });
        });
    }
  };

  /**
   * Con esta funcion descargamos los reportes, solo es pasarle ciertos datos y el se encarga de la lógica
   * @param body DownloadReportsModel
   * @param msgLoading string | undefined
   * @param msgSuccess string | undefined
   * @param msgError string | undefined
   * @param msgAlert string
   * @param generatedFileName string
   * @param urlAPI string
   */
  const downloadReport = (
    body: DownloadReportsModel,
    msgLoading: string | undefined = langResources['download.reports.message.loading'],
    msgSuccess: string | undefined = langResources['download.reports.message.success'],
    msgError: string | undefined = langResources['download.reports.message.error'],
    msgAlert: string,
    generatedFileName: string,
    urlAPI: string,
    extension: string = 'xlsx',
  ) => {
    const id = toast.loading(msgLoading);

    requests
      .postWithParameters(urlAPI, body, { responseType: 'blob' })
      .then((res) => {
        fileDownload(res, `${generatedFileName}-${new Date().toLocaleDateString()}.${extension}`);
        toast.update(id, {
          render: msgSuccess,
          type: 'success',
          isLoading: false,
          autoClose: 5000,
        });
      })
      .catch((err) =>
        toast.update(id, {
          render: msgError,
          type: 'error',
          isLoading: false,
          autoClose: 5000,
        }),
      );
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee  EmployeeNodeModel[]
   * @returns Abre el modal para poder realizar las asignaciones de los turnos
   */
  const handlerOpenWorkshiftModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableShiftProgramming',
    );

    if (!getActionService(userInfo.actions, ACTIONS['create.workshift.scheduling'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      setIsOpenWorkshiftModal(true);
      setModalInfoWorkshift({
        startDate: initDate,
        endDate: lastDate,
        employee: employee,
      });
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        setIsOpenWorkshiftModal(true);
        setModalInfoWorkshift({
          startDate: initDate,
          endDate: lastDate,
          employee: employee,
        });
      }
    }
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee EmployeeNodeModel[]
   * @param costCenters Array of cost centers with hour ranges
   * @param parentNodeSelected number[]
   * @returns Abre el modal para poder asignar múltiples centros de costo por rango de horas
   */
  const handlerOpenMultipleCostCentersByHourRangesModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
    costCenters: Array<{
      costCenterId: number;
      costCenterName: string;
      startTime: string;
      endTime: string;
    }>,
    parentNodeSelected: number[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['modify.news'])) {
      return;
    }

    setModalInfoMultipleCostCentersByHourRanges({
      startDate: initDate,
      endDate: lastDate,
      employee,
      costCenters,
      parentNodeSelected,
    });

    setIsOpenMultipleCostCentersByHourRangesModal(true);
  };

  const handlerOpenBonusModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['assign.bonus'])) {
      return;
    }
    setIsOpenBonusModal(true);

    setModalInfoBonus({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @param id number[]
   * @returns Abre el modal para poder eliminar los turnos
   */
  const handlerOpenDeleteWorkshiftModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
    id: number[],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableShiftProgramming',
    );

    if (!getActionService(userInfo.actions, ACTIONS['delete.workshift.scheduling'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      setIsOpenDeleteWorkshiftModal(true);
      setModalInfoWorkshift({
        startDate: initDate,
        endDate: lastDate,
        employee: employee,
        id,
      });
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        setIsOpenDeleteWorkshiftModal(true);
        setModalInfoWorkshift({
          startDate: initDate,
          endDate: lastDate,
          employee: employee,
          id,
        });
      }
    }
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @param workshifts WorkshiftSchedulingModel[]
   * @returns Abre el modal para asignar las interrupciones
   */
  const handlerOpenInteruptionModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
    workshifts: WorkshiftSchedulingModel[],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableTurnInterruption',
    );

    if (!getActionService(userInfo.actions, ACTIONS['modify.interruption'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      setIsOpenCreateInterruptionModal(true);
      setModalInfoInterruption({
        startDate: initDate,
        endDate: lastDate,
        employee,
        workshifts,
      });
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        setIsOpenCreateInterruptionModal(true);
        setModalInfoInterruption({
          startDate: initDate,
          endDate: lastDate,
          employee,
          workshifts,
        });
      }
    }
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @param interruption InterruptionModel[][]
   * @returns Abre el modal para modificar y eliminar las interrupciones asignadas
   */
  const handlerOpenUpdateAndDeleteInterruptionsModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
    interruption: InterruptionModel[][],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableTurnInterruption',
    );

    if (!getActionService(userInfo.actions, ACTIONS['modify.interruption'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      setModalUpdatedAndDeleteInfo({
        startDate: initDate,
        endDate: lastDate,
        employee,
        interruption,
        interruptionCopy: interruption,
      });
      setIsOpenUpdateAndDeleteModal(true);
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        setModalUpdatedAndDeleteInfo({
          startDate: initDate,
          endDate: lastDate,
          employee,
          interruption,
          interruptionCopy: interruption,
        });
        setIsOpenUpdateAndDeleteModal(true);
      }
    }
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder asignar horas adicionales
   */
  const handlerOpenAdditionalHours = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableAdditional',
    );

    if (!getActionService(userInfo.actions, ACTIONS['create.additional'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      setIsOpenAdditionalHoursModal(true);
      setModalAddtionalInfo({
        startDate: initDate,
        endDate: lastDate,
        employee,
      });
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        setModalAddtionalInfo({
          startDate: initDate,
          endDate: lastDate,
          employee,
        });
        setIsOpenAdditionalHoursModal(true);
      }
    }
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee  EmployeeNodeModel[]
   * @param additonalsList InterruptionModel[][]
   * @returns Abre el modal para poder actualizar o eliminar horas adicionales
   */
  const handlerOpenUpdateAndDeleteAdditionalHoursModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
    additonalsList: InterruptionModel[][],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableAdditional',
    );

    if (!getActionService(userInfo.actions, ACTIONS['modify.additionals'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      setModalUpdatedAndDeleteAdditionalHours({
        employee,
        initDate,
        lastDate,
        additionals: additonalsList,
        additionalsCopy: additonalsList,
      });
      setIsOpenUpdateAndDeleteAdditionalHoursModal(true);
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        setModalUpdatedAndDeleteAdditionalHours({
          employee,
          initDate,
          lastDate,
          additionals: additonalsList,
          additionalsCopy: additonalsList,
        });
        setIsOpenUpdateAndDeleteAdditionalHoursModal(true);
      }
    }
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee EmployeeNodeModel[]
   * @param parentNodeSelected number[]
   * @returns Abre el modal para poder asignar centros de costo
   */
  const handlerOpenCostCenterModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
    parentNodeSelected: number[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['modify.news'])) {
      return;
    }

    setModalAssociateCostCenter({
      startDate: initDate,
      endDate: lastDate,
      employee,
      parentNodeSelected,
    });
    setIsOpenCostCenterModal(true);
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder asignar unidades de negocio
   */
  const handlerBusinessUnitsModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['modify.news'])) {
      return;
    }

    setModalAssociateBusinessUnits({
      employee,
      endDate: lastDate,
      startDate: initDate,
    });
    setIsOpenBusinessUnitsModal(true);
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee EmployeeNodeModel[]
   * @param listToDelete DisassociateCostCenterModel[]
   * @returns Abre el modal para poder eliminar los centros de costo asociados
   */
  const handlerOpenDisassociatedCostCenterModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
    listToDelete: DisassociateCostCenterModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['modify.news'])) {
      return;
    }

    setModalDisassociateCostCenter({
      startDate: initDate,
      endDate: lastDate,
      employee,
      listToDelete,
    });
    setIsOpenDisassociatedCostCenterModal(true);
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal
   * @param initDate string
   * @param lastDate string
   * @param employee EmployeeNodeModel[]
   * @param listToDelete DisassociateBusinessUnitModel[]
   * @returns Abre el modal para poder eliminar unidades de negocio
   */
  const handlerDisassociatedBusinessUnitsModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
    listToDelete: DisassociateBusinessUnitModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['modify.news'])) {
      return;
    }

    setModalDisassociateBusinessUnits({
      employee,
      endDate: lastDate,
      startDate: initDate,
      listToDelete,
    });
    setIsOpenDisassociatedBusinessUnitsModal(true);
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo esta correcto procede abrir el modal -- No esta en uso
   * @param date string
   * @param employee EmployeeNodeModel
   */
  const handlerOpenAidTypeModal = (date: string, employee: EmployeeNodeModel) => {
    setIsOpenAidTypesModal(true);
    setMoldaAidTypesInfo({
      date,
      employee,
    });
  };

  /**
   * Guarda las programaciones que se copiaron y se desean pegar en otro lado
   * @param workshiftIds WorkshiftSchedulingsIds[]
   * @param workshifts WorkshiftSchedulingModel[]
   */
  const handlerCopyWorkshiftsSchedulings = (
    workshiftIds: WorkshiftSchedulingsIds[],
    workshifts: WorkshiftSchedulingModel[],
  ) => {
    setWorkshiftsSchedulingsCopied({
      toCopy: workshiftIds,
      workshiftsCopied: workshifts,
    });
  };

  /**
   * Envia la informacion de las programaciones que se copiaron a una API para que realice las asignaciones y se vuelve a consultar la programación
   * @param initDate  string
   * @param startDate string
   * @param lastDate string
   * @param endDate string
   * @param selectedEmployees EmployeeNodeModel[]
   * @param employeesTree EmployeeNodeModel[]
   */
  const handlerSavePasteWorkshiftsSchedulings = (
    initDate: string,
    startDate: string,
    lastDate: string,
    endDate: string,
    selectedEmployees: EmployeeNodeModel[],
    employeesTree: EmployeeNodeModel[],
  ) => {
    const parameter = parametersApplication.find(
      (parameter) => parameter.name === 'NumberOfDaysToEnableShiftProgramming',
    );

    if (!getActionService(userInfo.actions, ACTIONS['create.workshift.scheduling'])) {
      return;
    }

    if (getActionService(userInfo.actions, ACTIONS['modify.workshift.scheduling.before.time'])) {
      const id = toast.loading(langResources['paste.programation']['loading']);

      let body = {
        copyRanges: workshiftsSchedulingsCopied.toCopy,
        employeeIds: getEmployeesIds(selectedEmployees),
        startDate: initDate,
        endDate: lastDate,
      };

      WorkshiftsSchedulingAPI.savePasteWorkshiftsSchedulings(body)
        .then((res) => {
          if (res.daysResponse.data.length > 0) {
            let daysWithoutWorkshiftScheduling =
              //@ts-ignore
              res.daysResponse.data.map((e) => e.name);
            toast.update(id, {
              render: res.daysResponse.message + ': ' + daysWithoutWorkshiftScheduling,
              type: 'warning',
              isLoading: false,
              autoClose: 5000,
              position: toast.POSITION.BOTTOM_RIGHT,
              closeOnClick: true,
              closeButton: true,
            });
          } else {
            toast.update(id, {
              render: langResources['paste.programation']['loading.succes'],
              type: 'success',
              isLoading: false,
              autoClose: 5000,
              position: toast.POSITION.BOTTOM_RIGHT,
              closeOnClick: true,
              closeButton: true,
            });
          }
          handleConsultScheduling(employeesTree, startDate, endDate, false, []);
        })
        .catch((err) => {
          toast.update(id, {
            render: err.response.data,
            type: 'error',
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
          });
        });

      setWorkshiftsSchedulingsCopied({
        toCopy: [],
        workshiftsCopied: [],
      });
    } else {
      if (compareTwoDates(initDate.toString(), Number(parameter?.value))) {
        setOpenAlertModal({
          isOpen: true,
          message: parameter?.description ?? '',
          value: parameter?.value.toString() ?? '',
        });
      } else {
        const id = toast.loading(langResources['paste.programation']['loading']);

        let body = {
          copyRanges: workshiftsSchedulingsCopied.toCopy,
          employeeIds: getEmployeesIds(selectedEmployees),
          startDate: initDate,
          endDate: lastDate,
        };

        WorkshiftsSchedulingAPI.savePasteWorkshiftsSchedulings(body)
          .then((res) => {
            handleConsultScheduling(employeesTree, startDate, endDate, false, []);
            toast.update(id, {
              render: langResources['paste.programation']['loading.succes'],
              type: 'success',
              isLoading: false,
              autoClose: 5000,
              position: toast.POSITION.BOTTOM_RIGHT,
              closeOnClick: true,
              closeButton: true,
            });
          })
          .catch((err) => {
            toast.update(id, {
              render: err.response.data,
              type: 'error',
              isLoading: false,
              autoClose: 5000,
              position: toast.POSITION.BOTTOM_RIGHT,
              closeOnClick: true,
              closeButton: true,
            });
          });

        setWorkshiftsSchedulingsCopied({
          toCopy: [],
          workshiftsCopied: [],
        });
      }
    }
  };

  /**
   * Al pasarle la informacion necesaria la función se encarga de moldearla y enviarla a la API que realizara la asignación y se vuelve a consultar la programación
   * @param workshiftIds number[] of workshift
   * @param startDate string date
   * @param endDate string date
   * @param selectedEmployees EmployeeNodeModel object
   * @returns
   */
  const saveExceptionalWorkshiftsScheduling = (
    workshiftIds: number[],
    startDate: string,
    endDate: string,
    selectedEmployees: EmployeeNodeModel[],
  ) => {
    if (
      !getActionService(userInfo.actions, ACTIONS['modify.news']) ||
      !getActionService(userInfo.actions, ACTIONS['create.exceptional'])
    ) {
      return;
    }

    const id = toast.loading(langResources['save.exceptional.workshift.scheduling']['loading']);

    const body = {
      workshiftSchedulingIds: workshiftIds,
    };

    WorkshiftsSchedulingAPI.saveExceptionalWorkshiftsScheduling(body)
      .then((res) => {
        handleConsultScheduling(selectedEmployees, startDate, endDate, false, []);

        toast.update(id, {
          render: langResources['save.exceptional.workshift.scheduling']['success'],
          type: 'success',
          isLoading: false,
          autoClose: 5000,
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: true,
          closeButton: true,
        });
      })
      .catch((err) => {
        toast.update(id, {
          render: err.response.data,
          type: 'error',
          isLoading: false,
          autoClose: 5000,
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: true,
          closeButton: true,
        });
      });

    window.localStorage.removeItem('selection-range');
    setIsOpenWorkshiftModal(false);
  };

  /**
   * Al indicarle que programaciones que queremos removerles los excepcionales este envia la información a la API y vuelve a realizar la consulta
   * @param workshiftIds number[]
   * @param startDate string
   * @param endDate string
   * @param selectedEmployees EmployeeNodeModel[]
   * @returns
   */
  const removeExceptionalWorkshiftsScheduling = (
    workshiftIds: number[],
    startDate: string,
    endDate: string,
    selectedEmployees: EmployeeNodeModel[],
  ) => {
    if (
      !getActionService(userInfo.actions, ACTIONS['modify.news']) ||
      !getActionService(userInfo.actions, ACTIONS['create.exceptional'])
    ) {
      return;
    }

    const id = toast.loading(langResources['remove.exceptional.workshift.scheduling']['loading']);

    const body = {
      workshiftSchedulingIds: workshiftIds,
    };

    WorkshiftsSchedulingAPI.removeExceptionalWorkshiftsScheduling(body)
      .then((res) => {
        handleConsultScheduling(selectedEmployees, startDate, endDate, false, []);

        toast.update(id, {
          render: langResources['remove.exceptional.workshift.scheduling']['success'],
          type: 'success',
          isLoading: false,
          autoClose: 5000,
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: true,
          closeButton: true,
        });
      })
      .catch((err) => {
        toast.update(id, {
          render: err.response.data,
          type: 'error',
          isLoading: false,
          autoClose: 5000,
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: true,
          closeButton: true,
        });
      });

    window.localStorage.removeItem('selection-range');
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @param workshifts WorkshiftSchedulingModel[]
   * @returns Abre el modal para poder insertar marcaciones
   */
  const handlerOpenAssociateMarkingModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
    workshifts: WorkshiftSchedulingModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['associate.markings'])) {
      return;
    }

    setIsOpenCreateMarkingModal(true);
    setModalCreateMarking({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
      workshifts,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @param workshifts WorkshiftSchedulingModel[]
   * @returns Abre el modal para poder modificar marcaciones
   */
  const handlerOpenModifyMarkingModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
    workshifts: WorkshiftSchedulingModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['associate.markings'])) {
      return;
    }

    setIsOpenModifyMarkingModal(true);
    setModalModifyMarking({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
      workshifts,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder ver los detalles de las inconsistencias
   */
  const handlerOpenDetailsInconsistenciesModal = (
    initDate: string | number,
    lastDate: string | number,
    employee: EmployeeNodeModel[],
    inconsistencies: InconsistenciesByEmployeeModel[],
  ) => {
    setIsOpenDetailsInconsistenciesModal(true);
    setDetailsInconsistenciesModal({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
      inconsistencies: inconsistencies,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder ver los filtros para las inconsistencias
   */
  const handlerOpenInconsistenciesModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['management.scheduling'])) {
      return;
    }

    setIsOpenInconsistenciesModal(true);
    setInconsistenciesModal({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder ver los filtros para las inconsistencias
   */
  const handlerValidationWorkshiftsSundaysUsuals = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
  ) => {
    if (
      !getActionService(
        userInfo.actions,
        ACTIONS['AllowValidatingTheUsualSundayWorkShiftSchedules'],
      )
    ) {
      return;
    }

    setIsOpenWorkshiftsSundaysUsualsModal(true);
    setWorkshiftsSundaysUsualsModal({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder ver los filtros para las inconsistencias
   */
  const handlerOpenOperationsCenterModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['assingSchedule.operationCenter'])) {
      return;
    }

    setIsOpenOperationsCenterModal(true);
    setModalInfoOperationsCenter({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
    });
  };

  /**
   * Esa funcion valida que tenga los permisos, que los datos si esten bien y si todo es correcto procede abrir el modal
   * @param initDate string | number
   * @param lastDate string | number
   * @param employee EmployeeNodeModel[]
   * @returns Abre el modal para poder ver los filtros para las inconsistencias
   */
  const handlerDeleteOperationsCenterModal = (
    initDate: string,
    lastDate: string,
    employee: EmployeeNodeModel[],
    ids: number[],
  ) => {
    if (!getActionService(userInfo.actions, ACTIONS['deleteSchedule.operationCenter'])) {
      return;
    }

    setIsDeleteOperationsCenterModal(true);
    setModalInfoOperationsCenter({
      startDate: initDate,
      endDate: lastDate,
      employee: employee,
      id: ids,
    });
  };

  return (
    <AppContext.Provider
      value={{
        inconsistenciesTypesToFilter,
        setInconsistenciesTypesToFilter,
        isLoadingWorkshifts,
        setIsLoadingWorkshifts,
        inconsistenciesModal,
        handlerOpenInconsistenciesModal,
        isOpenInconsistenciesModal,
        setIsOpenInconsistenciesModal,
        allTimeAttendanceEvents,
        detailsInconsistenciesModal,
        setDetailsInconsistenciesModal,
        isOpenDetailsInconsistenciesModal,
        setIsOpenDetailsInconsistenciesModal,
        handlerOpenDetailsInconsistenciesModal,
        handlerValidationWorkshiftsSundaysUsuals,
        lang,
        appVersion,
        isSkinSmart,
        isCollapseTree,
        setIsCollapseTree,
        langResources,
        workshiftsSchedulingsCopied,
        userInfo,
        parametersApplication,
        showEmployeesTable,
        workshiftShedulingList,
        interruptionList,
        interruptionTypesList,
        grid,
        hourTypes,
        businessUnitsList,
        areasList,
        groupList,
        interruptionReferenceTypesList,
        inconsistenciesValidation,
        holidaysList,
        aidTypesList: aidTypesList,
        workshiftUsed,
        isOpenAdditionalHoursModal,
        isOpenAidTypesModal,
        isOpenBusinessUnitsModal,
        isOpenCostCenterModal,
        isOpenCreateInterruptionModal,
        isOpenDeleteWorkshiftModal,
        isOpenUpdateAndDeleteAdditionalHoursModal,
        isOpenUpdateAndDeleteModal,
        isOpenDisassociatedCostCenterModal,
        isOpenDisassociatedBusinessUnitsModal,
        isOpenMultipleCostCentersByHourRangesModal,
        setIsOpenMultipleCostCentersByHourRangesModal,
        modalInfoMultipleCostCentersByHourRanges,
        setModalInfoMultipleCostCentersByHourRanges,
        isOpenCostCenterScheduleResultsModal,
        setIsOpenCostCenterScheduleResultsModal,
        costCenterScheduleResults,
        setCostCenterScheduleResults,
        modalDisassociateCostCenter,
        modalDisassociateBusinessUnits,
        isOpenWorkshiftModal,
        isOpenBonusModal,
        modalAddtionalInfo,
        modalAssociateBusinessUnits,
        modalAssociateCostCenter,
        modalInfoInterruption,
        modalInfoWorkshift,
        modalInfoBonus,
        modalUpdatedAndDeleteAdditionalHours,
        modalUpdatedAndDeleteInfo,
        moldaAidTypesInfo,
        openAlertModal,
        interruptionTypesByEmployeePortalList,
        interruptionTypesByUserList,
        setWorkshiftUsed,
        setGrid,
        setShowEmployeesTable,
        handleConsultScheduling,
        downloadReport,
        handlerOpenWorkshiftModal,
        handlerOpenBonusModal,
        handlerBusinessUnitsModal,
        handlerOpenDeleteWorkshiftModal,
        handlerOpenInteruptionModal,
        handlerOpenUpdateAndDeleteInterruptionsModal,
        handlerOpenAdditionalHours,
        handlerOpenUpdateAndDeleteAdditionalHoursModal,
        handlerOpenCostCenterModal,
        handlerOpenAidTypeModal,
        handlerDisassociatedBusinessUnitsModal,
        handlerOpenDisassociatedCostCenterModal,
        handlerCopyWorkshiftsSchedulings,
        handlerSavePasteWorkshiftsSchedulings,
        handlerOpenMultipleCostCentersByHourRangesModal,
        removeExceptionalWorkshiftsScheduling,
        setIsOpenDeleteWorkshiftModal,
        setIsOpenAidTypesModal,
        setIsOpenBusinessUnitsModal,
        setIsOpenWorkshiftModal,
        setIsOpenBonusModal,
        setModalInfoWorkshift,
        setIsOpenCreateInterruptionModal,
        setIsOpenUpdateAndDeleteAdditionalHoursModal,
        setIsOpenUpdateAndDeleteModal,
        setIsOpenAdditionalHoursModal,
        setOpenAlertModal,
        setIsOpenCostCenterModal,
        setIsOpenDisassociatedBusinessUnitsModal,
        setIsOpenDisassociatedCostCenterModal,
        saveExceptionalWorkshiftsScheduling,
        setIsOpenWorkshiftsSundaysUsualsModal,
        setLang,
        workshiftList,
        workshiftListCopy,
        isLoadingDataList,
        setWorkshiftListCopy,
        setIsLoadingData,
        handlerOpenAssociateMarkingModal,
        handlerOpenModifyMarkingModal,
        isOpenCreateMarkingModal,
        isOpenModifyMarkingModal,
        setIsOpenCreateMarkingModal,
        setIsOpenModifyMarkingModal,
        modalCreateMarking,
        modalModifyMarking,
        handlerValidateNovelties,
        employeesToShowTable,
        setEmployeesToShowTable,
        handlerOpenOperationsCenterModal,
        modalInfoOperationsCenter,
        isOpenOperationsCenterModal,
        isDeleteOperationsCenterModal,
        handlerDeleteOperationsCenterModal,
        setIsOpenOperationsCenterModal,
        setIsDeleteOperationsCenterModal,
        employeesSelectedBackup,
        setEmployeesSelectedBackup,
        isOpenWorkshiftsSundaysUsualsModal,
        workshiftsSundaysUsualsModal,
        isRequestHistoryModalOpen,
        setIsRequestHistoryModalOpen,
        endDateScheduling,
        selectedEmployees,
        setEndDateScheduling,
        setSelectedEmployees,
        setStartDateScheduling,
        startDateScheduling,
        activeSkinConfig,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
